import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import UserSettingsPassword from './UserSettingsPassword';

interface Props extends BaseModalProps {
	userId: string;
	onSuccess: () => void;
}

const UserSettingsPasswordModal: React.FC<Props> = props => (
	<BaseModal {...props} title='base.shared.passwordChange'>
		<UserSettingsPassword userId={props.userId} onSuccess={props.onSuccess} />
	</BaseModal>
);

export default UserSettingsPasswordModal;
